<script>
    export let form, update;
</script>

<div id="affidavit_of_non_use">
    <p class="alert alert-danger py-2">
        There are late penalties associated with this vehicle. Please read the
        below carefully.
    </p>

    <p>
        The transferee of any new or used vehicle, required by law to be
        registered, shall apply for, or cause to be applied for, the
        registration thereof within thirty (30) days after the date of the
        release of a lien by the prior lienholder, or thirty days after the date
        of transfer if no lien exists (A.C.A &sect;27-14-903). Any person
        operating a passenger motor vehicle or class one (1) truck after the
        time set for registration shall be required to pay a penalty of three
        dollars ($3.00) for each ten (10) days, or a fraction thereof, for which
        he fails to properly register the vehicle until the penalty reaches the
        amount of the license fee of the vehicle to be registered [A.C.A.
        &sect;27-14-1004(a)].
    </p>

    <p>
        <strong>
            Provided, however, no penalty shall be assessed if the owner makes
            an affidavit to the effect that the vehicle has not been operated on
            any street, road, or highway in the State of Arkansas after the time
            set for registering the motor vehicle [A.C.A &sect;27-14-1004(b)].
            If such affidavit shall be false, the making of the affidavit shall
            constitute a misdemeanor and shall be punishable by a fine of from
            two hundred fifty dollars ($250) to five hundred dollars ($500)
            [A.C.A &sect;27-14-1004(c)].
        </strong>
    </p>

    <p><strong>Affirmation</strong></p>

    <div class="form-check">
        <input
            type="checkbox"
            class="form-check-input"
            id="affidavit"
            bind:checked={$form.affidavit}
            on:change={update}
            value="1"
        />
        <label class="form-check-label" for="affidavit">
            I swear and affirm that the vehicle described above has not been
            used on the public highways of this state past the time set for
            registration, as described above. I further swear and affirm that I
            am aware of the penalty for making a false affidavit, as described
            above.
        </label>
    </div>
</div>
